import classes from './VictoryLiveLogo.module.css';

interface LogoProps {
  size?: number;
}

export default function VictoryLiveLogo({ size = 48 }: LogoProps) {
  return (
    <svg className={classes.victoryLiveLogo} height={size} width={size} viewBox="0 0 376 361" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M348.998 0H243.758H242.759L225.774 79.5985L188.473 241.793L151.507 79.5985L134.522 0H133.522H28.2825H25.6182L188.473 324.722L351.663 0H348.998Z"
        fill="var(--colors-victoryLivePrimary)"
      />
      <path d="M361.014 71.9218L188.167 354.347L14.9867 71.9218L0 155.184L188.167 361.008L376 155.184L361.014 71.9218Z" fill="var(--colors-victoryLiveAccent)" />
    </svg>
  );
}
